import { IMediaItem } from '../models/Interfaces';

export const mediaDisplayName = (metadata: string | null | undefined, fallback: string): string => {
  try {
    const name = JSON.parse(metadata || '{}')?.displayName;
    return typeof name === 'string' && name.trim() ? name : fallback;
  } catch { return fallback; }
};

export const withMediaDisplayName = (file: IMediaItem): IMediaItem => ({
  ...file,
  Filename: mediaDisplayName(file.MetadataJson, file.Filename),
  SrcSet: file.SrcSet?.map(withMediaDisplayName),
});
